import React, { useState,useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import GradeEntryFormCourse from "../components/GradeEntryFormCourse";
import marksentryapi from '../api/gradeEntryRouter';
import loginapi from '../api/login';

import { APISERVERURL } from '../APIServerURL';


const GradeEntryForm = ({accessToken,setAccessToken,setRefreshFailed}) => {
  const navigate = useNavigate();
  const { courseCode,session,batch } = useParams();
  const [studentListLoaded,setStudentListLoaded]=useState(false);
  const [courseDetailsLoaded,setCourseDetailsLoaded]=useState(false);
  
  const [marksData, setMarksData] = useState([]);
  const [courseDetails,setCourseDetails]=useState(null);
  const [submissionStatus,setSubmissionStatus]=useState('done');

  




  const handleAllowMarkEntry = async () => {
    const isConfirmed = window.confirm("This action will allow the raw marks to be edited from the MARKS ENTRY page. Are you sure you want to continue?");
    if (isConfirmed) {
      // Proceed with the actual work
      setStudentListLoaded(false);
      setCourseDetailsLoaded(false);
      try{       
        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
        const response=await marksentryapi.post('/allowMarksEntry',{batch,session,courseCode},{headers:{'Authorization':`Bearer ${accessToken}`}});  
        await fetchAllFormFillupStudents();
        await fetchBatchSubmissionDetails();
        }
        catch(err)
        {
          if( err.response.status===403)
            {
              navigate(`/accessdenied`); 
            }
          try{
            const config = { withCredentials: true };
            const x=await loginapi.get('/getAccessToken',config);            
            const nat=x['data']['accessToken'];
            const lt=x['data']['loginType'];
            //alert(nat);
            setAccessToken(nat);
            setRefreshFailed(false);  
                    
           
              if(lt.toLowerCase()==="admin")
                {
                      try{       
                        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                        const response=await marksentryapi.post('/allowMarksEntry',{batch,session,courseCode},{headers:{'Authorization':`Bearer ${nat}`}});   
                        await fetchAllFormFillupStudents();
                        await fetchBatchSubmissionDetails();
                    }
                    catch(err)
                    {
                      if( err.response.status===403)
                        {
                          navigate(`/accessdenied`); 
                        }
                      //alert('refresh failed unusual'+JSON.stringify(err));
                      setAccessToken('');
                      setRefreshFailed(true);  
                    }
                  }
            }
            catch(err)
            {
              //alert('dd');
              setAccessToken(''); 
              setRefreshFailed(true);              
            }
        }         
         finally
            {
              //setIsAppLoaded(true);
              //alert('app loaded'+accessToken);
            }
      
    } else {
      
    }
  };


  const handleComputeGrade = async () => {
    const isConfirmed = window.confirm("This action will overwrite the grades. Are you sure you want to continue?");
    if (isConfirmed) {
      // Proceed with the actual work
      setStudentListLoaded(false);
      try{       
        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
        const response=await marksentryapi.post('/updateGradesOfABatch',{batch,session,courseCode},{headers:{'Authorization':`Bearer ${accessToken}`}});  
        await fetchAllFormFillupStudents();
        }
        catch(err)
        {
          if( err.response.status===403)
            {
              navigate(`/accessdenied`); 
            }
          try{
            const config = { withCredentials: true };
            const x=await loginapi.get('/getAccessToken',config);            
            const nat=x['data']['accessToken'];
            const lt=x['data']['loginType'];
            //alert(nat);
            setAccessToken(nat);
            setRefreshFailed(false);  
                    
           
              if(lt.toLowerCase()==="admin")
                {
                      try{       
                        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                        const response=await marksentryapi.post('/updateGradesOfABatch',{batch,session,courseCode},{headers:{'Authorization':`Bearer ${nat}`}});   
                        await fetchAllFormFillupStudents();
                    }
                    catch(err)
                    {
                      if( err.response.status===403)
                        {
                          navigate(`/accessdenied`); 
                        }
                      //alert('refresh failed unusual'+JSON.stringify(err));
                      setAccessToken('');
                      setRefreshFailed(true);  
                    }
                  }
            }
            catch(err)
            {
              //alert('dd');
              setAccessToken(''); 
              setRefreshFailed(true);              
            }
        }         
         finally
            {
              //setIsAppLoaded(true);
              //alert('app loaded'+accessToken);
            }
      
    } else {
    }
  };
  const handleClick = async () => {
    const isConfirmed = window.confirm("After submit you wont be able to edit the grades. Are you sure you want to submit?");
    if (isConfirmed) {
      // Proceed with the actual work
      setStudentListLoaded(false);
      setCourseDetailsLoaded(false);
      try{       
        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
        const response=await marksentryapi.post('/submitGrades',{batch,session,courseCode},{headers:{'Authorization':`Bearer ${accessToken}`}});  
        await fetchAllFormFillupStudents();
        await fetchBatchSubmissionDetails();
        }
        catch(err)
        {
          if( err.response.status===403)
            {
              navigate(`/accessdenied`); 
            }
          try{
            const config = { withCredentials: true };
            const x=await loginapi.get('/getAccessToken',config);            
            const nat=x['data']['accessToken'];
            const lt=x['data']['loginType'];
            //alert(nat);
            setAccessToken(nat);
            setRefreshFailed(false);  
                    
           
              if(lt.toLowerCase()==="admin")
                {
                      try{       
                        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                        const response=await marksentryapi.post('/submitGrades',{batch,session,courseCode},{headers:{'Authorization':`Bearer ${nat}`}});   
                        await fetchAllFormFillupStudents();
                        await fetchBatchSubmissionDetails();
                    }
                    catch(err)
                    {
                      if( err.response.status===403)
                        {
                          navigate(`/accessdenied`); 
                        }
                      //alert('refresh failed unusual'+JSON.stringify(err));
                      setAccessToken('');
                      setRefreshFailed(true);  
                    }
                  }
            }
            catch(err)
            {
              //alert('dd');
              setAccessToken(''); 
              setRefreshFailed(true);              
            }
        }         
         finally
            {
              //setIsAppLoaded(true);
              //alert('app loaded'+accessToken);
            }
      
    } else {
      
    }
  };
  
  const handleGoBack = () => {
    navigate(`/gradeentrybatches/${courseCode}/${session}`); 
  };



 
// Handle grade change
const handleGradeChange = async (rollno, newGrade) => {
          try {
            //update courseCode,session ,marksData[index][rollno],field,value
          const response=await marksentryapi.post('/updateGrade',{session:session,courseCode:courseCode,rollno:rollno,grade:newGrade},{headers:{'Authorization':`Bearer ${accessToken}`}});  
          if(response.data.updatedStudent && response.data.updatedStudent.grade===newGrade)
          {
            setMarksData((prevStudents) =>
              prevStudents.map((student) =>
                student.rollno === rollno ? { ...student, grade: newGrade } : student
              )
            );
          }
          
        } catch(err)
        {
          try{
            const config = { withCredentials: true };
            const x=await loginapi.get('/getAccessToken',config);            
            const nat=x['data']['accessToken'];
            const lt=x['data']['loginType'];
            //alert(nat);
            setAccessToken(nat);
            setRefreshFailed(false);  
                    
          
              if(lt.toLowerCase()==="admin")
                {
                      try{       
                        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                        const response=await marksentryapi.post('/updateGrade',{session:session,courseCode:courseCode,rollno:rollno,grade:newGrade},{headers:{'Authorization':`Bearer ${nat}`}});   
                        if(response.data.updatedStudent && response.data.updatedStudent.grade===newGrade)
                          {
                            setMarksData((prevStudents) =>
                              prevStudents.map((student) =>
                                student.rollno === rollno ? { ...student, grade: newGrade } : student
                              )
                            );
                          }
                    }
                    catch(err)
                    {
                      //alert('refresh failed unusual'+JSON.stringify(err));
                      setAccessToken('');
                      setRefreshFailed(true);  
                    }
                  }
            }
            catch(err)
            {
              //alert('dd');
              setAccessToken(''); 
              setRefreshFailed(true);              
            }
        }         
        finally
            {
              //setIsAppLoaded(true);
              //alert('app loaded'+accessToken);
            }  
};

const fetchAllFormFillupStudents=async ()=>{
    try{       
      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
      const response=await marksentryapi.post('/getAllFormFillupStudentsOfABatch',{session:session,courseCode:courseCode,batch:batch},{headers:{'Authorization':`Bearer ${accessToken}`}});  
      setMarksData(response.data.marksData);setStudentListLoaded(true);
      //alert(JSON.stringify(response.data.marksData.length));
      }
      catch(err)
      {        
        if( err.response.status===403)
          {
            navigate(`/accessdenied`); 
          }
        try{
          const config = { withCredentials: true };
          const x=await loginapi.get('/getAccessToken',config);            
          const nat=x['data']['accessToken'];
          const lt=x['data']['loginType'];
          //alert(nat);
          setAccessToken(nat);
          setRefreshFailed(false);  
                  
         
            if(lt.toLowerCase()==="admin")
              {
                    try{       
                      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                      const response=await marksentryapi.post('/getAllFormFillupStudentsOfABatch',{session:session,courseCode:courseCode,batch:batch},{headers:{'Authorization':`Bearer ${nat}`}});   
                      setMarksData(response.data.marksData);setStudentListLoaded(true);
                      //alert(JSON.stringify(response.data.marksData.length));
                  }
                  catch(err)
                  {
                    if( err.response.status===403)
                    {
                      navigate(`/accessdenied`); 
                    }
                    //alert('refresh failed unusual'+JSON.stringify(err));
                    setAccessToken('');
                    setRefreshFailed(true);  
                  }
                }
          }
          catch(err)
          {
            //alert('dd');
            setAccessToken(''); 
            setRefreshFailed(true);              
          }
      }         
       finally
          {
            //setIsAppLoaded(true);
            //alert('app loaded'+accessToken);
          }
  }

  const fetchBatchSubmissionDetails=async ()=>{
    try{ 
      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
      const response=await marksentryapi.post('/getBatchSubmissionDetails',{session:session,courseCode:courseCode,batch:batch},{headers:{'Authorization':`Bearer ${accessToken}`}});  
      setCourseDetails(response.data.courseDetails); 
      setSubmissionStatus(response.data.courseDetails.submissionStatus);

      

      setCourseDetailsLoaded(true);
      //alert(JSON.stringify(response.data.courseDetails));
      }
      catch(err)
      {
        
        if( err.response.status===403)
          {
            navigate(`/accessdenied`); 
          }
        try{
          const config = { withCredentials: true };
          const x=await loginapi.get('/getAccessToken',config);            
          const nat=x['data']['accessToken'];
          const lt=x['data']['loginType'];
          //alert(nat);
          setAccessToken(nat);
          setRefreshFailed(false);  
                  
         
            if(lt.toLowerCase()==="admin")
              {
                    try{       
                      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                      const response=await marksentryapi.post('/getBatchSubmissionDetails',{session:session,courseCode:courseCode,batch:batch},{headers:{'Authorization':`Bearer ${nat}`}});   
                      setCourseDetails(response.data.courseDetails);

                      

                      setSubmissionStatus(response.data.courseDetails.submissionStatus); 

                      setCourseDetailsLoaded(true);
                      //alert(response.data);
                         //alert(JSON.stringify(response.data.courseDetails));
                  }
                  catch(err)
                  {
                    if( err.response.status===403)
                      {
                        navigate(`/accessdenied`); 
                      }
                    //alert('refresh failed unusual'+JSON.stringify(err));
                    setAccessToken('');
                    setRefreshFailed(true);  
                  }
                }
          }
          catch(err)
          {
            //alert('dd');
            setAccessToken(''); 
            setRefreshFailed(true);              
          }
      }         
       finally
          {
            //setIsAppLoaded(true);
            //alert('app loaded'+accessToken);
          }
  }

useEffect(()=>{
   
  fetchAllFormFillupStudents();
  },[]);
  
useEffect(()=>{
   
  fetchBatchSubmissionDetails();
  },[]); 
  
  function downloadFile(fname)
      {
        fetch(`${APISERVERURL}/pdf/${fname}`).then((response) => {
          response.blob().then((blob) => {
           
              // Creating new object of PDF file
              const fileURL =
                  window.URL.createObjectURL(blob);
                   
              // Setting various property values
              let alink = document.createElement("a");
              alink.href = fileURL;
              alink.download = fname;
              alink.click();
              //setIsloading(false);
          });
        });
      }
  
  async function handleDownloadCSV(e)
      {
        e.preventDefault();
        try{
          const response= await marksentryapi.post('/getGradeEntryCSV',{session:session,courseCode:courseCode,batch},{headers:{'Authorization':`Bearer ${accessToken}`}});    
          alert(response.data);
          downloadFile(response.data);
        }
        catch(err)
        {
          try{
            const config = { withCredentials: true };
            const x=await loginapi.get('/getAccessToken',config);
            
            const nat=x['data']['accessToken'];
            setAccessToken(nat);
            try{       
              const response= await marksentryapi.post('/getGradeEntryCSV',{session:session,courseCode:courseCode,batch},{headers:{'Authorization':`Bearer ${nat}`}});    
              downloadFile(response.data);
             }
             catch(err)
             {
              alert('unusual error newposts.js');
             }
          }
          catch(err)
          {
            alert('failed');
          }
  
        }
      }
  
  
  return (
    <main className="flex flex-col items-center">
    <div className="text-center p-4">
      <h1 className="text-2xl text-gray-600">GRADE COMPUTATION FORM</h1>
      <p className="font-semibold text-xs">(The form is autosave)</p>
      {/* Add marks entry form here */}
    </div>
    {studentListLoaded && courseDetailsLoaded && <div className="w-[98%] max-w-[1200px]">
        <div className="w-full font-semibold border-b text-center">
            <p>{courseDetails?courseDetails.title:''}</p>
            <button 
              className="underline text-blue-600 hover:text-blue-800 cursor-pointer text-xs"
              onClick={handleDownloadCSV}
            >
              DOWNLOAD CSV
            </button>
        </div>
        <div className="w-full border-b  grid grid-cols-[1fr_1fr_3fr] gap-1 p-1 text-center">
            <div className="bg-white p-1">
                <div >
                    <p className="text-gray-700  font-small text-xs">CODE</p>
                    <p className="text-gray-900 font-medium text-md">  {courseDetails?courseDetails.code:''}</p>
                </div>
            </div>
            <div className="bg-white p-1">
                <div>
                    <p className="text-gray-700  font-small text-xs">Cr.</p>
                    <p className="text-gray-900 font-medium text-md">  {courseDetails?courseDetails.credit:''}</p>
                </div>
            </div>
            <div className="bg-white p-1 grid grid-cols-3 gap-2">
            <div className="text-center">
              <p className="text-gray-700  font-small text-xs">MID</p> 
              <p className="text-gray-900 font-medium text-md">
                {courseDetails?.midTermTotal ?? 0}
              </p>
            </div>
                <div className="text-center">
                    <p className="text-gray-700  font-small text-xs">EPR</p> 
                    <p className="text-gray-900 font-medium text-md">  {courseDetails?courseDetails.practicalTotal?courseDetails.practicalTotal:0:0}</p>
                </div> 
                <div className="text-center">
                    <p className="text-gray-700  font-small text-xs">ETH</p> 
                    <p className="text-gray-900 font-medium text-md">  {courseDetails?courseDetails.endTermTotal?courseDetails.endTermTotal:0:0}</p>
                </div> 
            </div>
        </div>

        
    <div className="w-full border bg-gray-100 grid grid-cols-[1fr_2fr_4fr_1fr_1fr_1fr_1fr_1fr_1fr_1.5fr] gap-1 p-1 mt-2 text-xs">
               <div  className="w-full text-center">
                SN
               </div>
               <div  className="w-full text-center">
                RLNO
               </div>
               <div  className="w-full text-center">
                NAME
               </div>
               <div  className="w-full text-center">
                MID
               </div>
               <div  className="w-full text-center">
                EPR
               </div>
               <div  className="w-full text-center">
                ETH
               </div>
               <div  className="w-full text-center">
                 {courseDetails?.midTermTotal > 0 ? 'M /30' : 'M /0'}
               </div>
               <div  className="w-full text-center">
                 {courseDetails?.midTermTotal > 0 ? '(ET+EP) /70' : '(ET+EP) /100'}
               </div>
               <div  className="w-full text-center">
                GTL /100
               </div>
               <div  className="w-full text-center">
                GRD
               </div>
        </div>
        {marksData.map((student, index) => (
          <GradeEntryFormCourse
            key={student.rollno}
            student={student}
            index={index}
            state={submissionStatus}// {courseDetails?courseDetails.submissionStatus?courseDetails.submissionStatus:'done':'done'}
            mt={(courseDetails?courseDetails.midTermTotal?courseDetails.midTermTotal:0:0||0)}
            pt={(courseDetails?courseDetails.practicalTotal?courseDetails.practicalTotal:0:0)}
            et={(courseDetails?courseDetails.endTermTotal?courseDetails.endTermTotal:0:0)}
            handleGradeChange={handleGradeChange}
          />
        ))}

    <div className="w-full flex justify-between p-2 mt-2 mb-2 flex flex-wrap">
      {/* GO BACK button */}
      <button 
        onClick={handleGoBack} 
        className="ml-2 mt-2 bg-green-500 text-white py-2 px-4 rounded hover:bg-gray-700 text-xs"
      >
        GO BACK
      </button>

      {submissionStatus === "gradecomputation" ? (
  <>
    <button 
      onClick={handleAllowMarkEntry} 
      className="ml-2 mt-2 bg-pink-500 text-white py-2 px-4 rounded hover:bg-gray-700 text-xs"
    >
      ALLOW MARK ENTRY
    </button>

    <button 
      onClick={handleComputeGrade} 
      className="ml-2 mt-2 bg-yellow-500 text-white py-2 px-4 rounded hover:bg-gray-700 text-xs"
    >
      COMPUTE GRADE
    </button>

    <button 
      onClick={handleClick} 
      className="ml-2 mt-2 bg-blue-500 text-white py-2 px-4 rounded hover:bg-gray-700 text-xs"
    >
      SUBMIT
    </button>
  </>
) : submissionStatus === "marksentry" ? (
  <button 
    disabled 
    className="ml-2 mt-2 bg-orange-300 text-gray-800 py-2 px-4 rounded text-xs cursor-not-allowed"
  >
    YET TO SUBMIT
  </button>
) : (
  <button 
    disabled 
    className="ml-2 mt-2 bg-gray-300 text-gray-600 py-2 px-4 rounded text-xs cursor-not-allowed"
  >
    ALREADY SUBMITTED
  </button>
)}
    
    </div>

    </div>
   }
   {
   (!studentListLoaded || !courseDetailsLoaded) && <div className="w-[98%] max-w-[1200px]">
    Please wait!
    </div>
    }
    </main>
  );
};

export default GradeEntryForm;
